export default __webpack_public_path__ + "static/media/rishi.02707e91.png";